"use strict";

export function initInScope($scope) {
    const $button = $scope.find(".js-comparison-area__share-btn");

    $button.on("click", function () {
        const url = $(this).val();

        if (url) {
            const originalText = $button.html();
            const successTooltip = $button.data("success-tooltip");

            navigator.clipboard.writeText(url)
                .then(() => {
                    $button.html(successTooltip + " <span class='icon icon-copy-checkmark' aria-hidden='true' role='img'></span>");

                    setTimeout(() => {
                        $button.html(originalText);
                    }, 2000);
                })
                .catch((err) => {
                    $button.html("{{ 'comparison.share-comparison.tooltip-error' | trans }}");

                    setTimeout(() => {
                        $button.html(originalText);
                    }, 2000);

                    console.error("Failed to copy: ", err);
                });
        }
    });
}